
export const buildPromoBlockProps = (block, state) => {
    const { props } = block;
    if (!props)
        return null;
    const buildProps = () => {
        let title = props.title?.default ?? null;
        let textTrans = props.textTrans?.default ?? null;
        let textLogo = props.textLogo?.default ?? null;
        let img = props.img?.default ? { ...props.img?.default, src: props.img?.default?.src } : null;
        let logo = props.logo?.default ? { ...props.logo?.default, src: props.logo?.default?.src } : null;
        let link = props?.link ?? null;
        return {
            title,
            textTrans,
            textLogo,
            img,
            logo,
            link
        };
    };

    const resolvedProps = buildProps();

    return {
        id: block.id,
        type: block.type,
        props: resolvedProps,
    };
};

